
































































































































import dayjs from 'dayjs';
import { Component, Vue } from 'vue-property-decorator';
import { CREATE_WAREHOUSE_PATCH } from '@/queries/WarehousePatch';
import { SmartQuery } from 'vue-apollo-decorator';
import { CURRENT_UNIT } from '@/queries/Application';
import { GQL_currentUnit, GQL_currentUnit_currentUnit } from '@/queries/__generated__/currentUnit';
import { generateUID } from '@/utils/utils';
import Decimal from 'decimal.js-light';
import { productPriceAt } from '@/app/Product';
import { IRules } from '@/components/UI/Form/ValidationModule';
import { validateMin, validateRequired, validateType } from '@/components/UI/Form/Validations';
import { GQL_productsWithAnySupplier } from '@/queries/__generated__/productsWithAnySupplier';
import gql from 'graphql-tag';

const PRODUCTS_WITH_ANY_SUPPLIER = gql`
  query productsWithAnySupplier(
    $limit: Int,
  ) {
    products(
      limit: $limit,
      filters: { withAnySupplier: true }
    ){
      id
      number
      name
      productPrices {
        id,
        purchasePrice,
        validTo,
        validFrom,
      }
      supplierUnit {
        id
        name
      }
    },
  },
`;

type CheckpointData = {
  date: string;
  unitId: string;
  comment: string;
  supplierData: CheckpointSupplierData[] | null;
}

type CheckpointSupplierData = {
  supplierUnitId: string;
  supplierUnitName: string;
  productData: Array<{
    productId: string;
    productNumber: string;
    productName: string;
    quantity: Decimal;
    purchasePrice: Decimal;
    totalPrice: Decimal;
    $_UID: string;
  }>;
}

@Component
export default class CheckpointPatchNew extends Vue {
  private data: CheckpointData | null = null;
  private CREATE_WAREHOUSE_PATCH = CREATE_WAREHOUSE_PATCH;

  @SmartQuery<CheckpointPatchNew, GQL_currentUnit>({
    query: CURRENT_UNIT,
    result({ data }) {
      this.data =  {
        unitId: data.currentUnit.id,
        date: dayjs().format('YYYY-MM-DD').toString(),
        comment: this.$t('WarehousePatch.newCheckpointPatchWarning').toString(),
        supplierData: null,
      };
      this.loadAllSuppliers();
    },
  }) private currentUnit!: GQL_currentUnit_currentUnit;

  loadAllSuppliers(): void {
    this.$apollo.query<GQL_productsWithAnySupplier>({
      query: PRODUCTS_WITH_ANY_SUPPLIER,
      // TODO revisit limit in case we have a need for more
      variables: { limit: 1000 },
      fetchPolicy: 'no-cache',
    }).then(data => {
      const grouped: Map<string | null, CheckpointSupplierData> = new Map();

      data.data.products.forEach(product => {
        const key = product.supplierUnit?.id || null;

        if (!grouped.has(key)) {
          grouped.set(key, {
            supplierUnitId: product.supplierUnit!.id,
            supplierUnitName: product.supplierUnit!.name,
            productData: [],
          });
        }

        grouped.get(key)!.productData.push({
          productId: product.id,
          productNumber: product.number,
          productName: product.name,
          quantity: new Decimal(0),
          purchasePrice: productPriceAt(this.$dayjs.strict(this.data!.date), product)?.purchasePrice || new Decimal(0),
          totalPrice: new Decimal(0),
          $_UID: generateUID(),
        });
      });

      this.data!.supplierData = Array.from(grouped.values());
    });
  }

  private validForm = true;
  private rules: IRules = {
    date: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: this.t_attr('WarehousePatch', 'date') }),
      },
      { validation: validateType('date'), message: i18n => i18n.t('GQL.Type.date') },
    ] ,
    warehousePatchLines: {
      purchasePrice: [
        {
          validation: validateMin(0),
          message: i18n => i18n.t('Error.cannotBeNegative', { field: this.t_attr('WarehousePatchLine','purchasePrice') }),
        },
      ],
    },
  }

  private lineSum(line: { quantity: Decimal; purchasePrice: Decimal }) {
    return line.quantity.times(line.purchasePrice);
  }

  private supplierSum(productData: CheckpointSupplierData['productData']) {
    return productData.reduce((sum, line) => sum.plus(this.lineSum(line)), new Decimal(0));
  }

  private formatForMutation() {
    return {
      warehousePatch: {
        unitId: this.currentUnit.id,
        comment: this.data!.comment,
        date: this.data!.date,
        supplierUnitId: null,
        warehousePatchLines: this.data!.supplierData!.flatMap(supplier => {
          return supplier.productData.map(product => ({
            productId: product.productId,
            quantity: product.quantity,
            purchasePrice: product.purchasePrice,
            productNumber: product.productNumber,
            productName: product.productName,
            checkpoint: true,
          }));
        }),
      },
    };
  }

  public patchesCreated() {
    this.$sMessage.success(this.$i18n.t('Message.saveSuccess'));
    this.$router.push({ path: '/warehouse'});
  }
}
